import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import useProperty from "../../context/useProperty";

export interface PubPropertyPayload {
  listType: string;
  searchTxt?: string;
  searchTxtPre?: string;
  showPre?: boolean;
  state?: string;
  offMarket?: boolean;
  occupancy?: string;
  salesInstruction?: string;
  status?: string;
  possession?: string;
  mapBounds: {
    topLeftLng: number;
    topLeftLat: number;
    bottomRightLng: number;
    bottomRightLat: number;
  };
}

export const useMapPublishProperties = ({ type }: { type: string }) => {
  const { t } = useTranslation();
  const axios = useAxios(type);
  const [searchParams] = useSearchParams();
  const { coords }: any = useProperty();
  const urlKey = `${t("property-list-api")}`;
  const searchTextValue = searchParams.get("searchText");
  const searchTxtPreValue = searchParams.get("searchTxtPre");
  const showPreValue = searchParams.get("showPre");
  const stateValue = searchParams.get("state");
  const offMarketValue = searchParams.get("offMarket");
  const occupancyValue = searchParams.get("occupancy");
  const salesInstructionsValue = searchParams.get("salesInstructions");
  const statusValue = searchParams.get("status");
  const possessionDeliveryValue = searchParams.get("possessionDelivery");
  const sortValue = searchParams.get("sort");
  const orderValue = searchParams.get("order");
  let payload: any = {
    listType: "map",
    mapBounds: coords,
    state: stateValue || "CA",
    ...(searchTextValue && { searchTxt: searchTextValue })
  };
  if (searchTextValue) {
    payload = { ...payload, searchTxt: searchTextValue };
  }
  if (searchTxtPreValue) {
    payload = { ...payload, searchTxtPre: searchTxtPreValue };
  }
  // Only fetch pre data if showPre is true (default to true if not set)
  payload = { ...payload, showPre: showPreValue === null ? true : showPreValue === "true" };
  if (stateValue) {
    payload = { ...payload, state: stateValue };
  }
  if (offMarketValue) {
    payload = { ...payload, offMarket: offMarketValue === "Yes" };
  }
  if (occupancyValue) {
    payload = { ...payload, occupancy: occupancyValue };
  }
  if (salesInstructionsValue) {
    payload = { ...payload, salesInstruction: salesInstructionsValue };
  }
  if (statusValue) {
    payload = { ...payload, status: statusValue };
  }
  if (possessionDeliveryValue) {
    payload = { ...payload, possession: possessionDeliveryValue };
  }
  if (sortValue) {
    payload = { ...payload, orderBy: sortValue };
  }
  if (orderValue) {
    payload = { ...payload, order: orderValue };
  }

  const {
    data: arrMapProperty,
    error,
    isLoading,
    refetch
  } = useQuery({
    queryKey: ["MapPublishProperties", payload],
    queryFn: async () => {
      const res = await axios.post(urlKey, payload); // Fetch data
      return res.data;
    },
    enabled: type === "agent"
  });

  return {
    arrMapProperty,
    error,
    isLoading,
    refetch // Use this to manually refetch the query
  };
};
